import * as React from 'react';
import { observer } from 'mobx-react';
import { DropdownView } from 'src/core/ui/dropdown.view';

interface AllotmentEditorViewProps {
	allotmentRequest: DropdownRequest<AllotmentSummary>;
	value: number | null;
	mode: ControlMode;
	onChanged: (number: number | null) => void;
	label?: string;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

@observer
export class AllotmentEditorView extends React.Component<AllotmentEditorViewProps, {}> {
	constructor(props: Readonly<AllotmentEditorViewProps>) {
		super(props);
	}

	render() {
		let label = this.props.label;
		if (label === undefined) {
			label = 'Allotment';
		}

		return (
			<DropdownView
				onGetErrorMessage={this.props.onGetErrorMessage}
				label={label}
				model={this.props.value}
				required={this.props.required}
				disabled={this.props.mode == 'display'}
				onChanged={(item) => { this.props.onChanged(item != null ? item.id : null) }}
				request={this.props.allotmentRequest}
				keyField='id'
				textField='name'
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/allotment/parts/allotment-editor.view.tsx